import { render, staticRenderFns } from "./OptionNumber.vue?vue&type=template&id=12da2350&"
import script from "./OptionNumber.vue?vue&type=script&lang=js&"
export * from "./OptionNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports